export const INITIALIZE = 'init'
export const INIT_SUCCESSFUL = 'init_successful'
export const INIT_FAILED = 'init_failed'

export const GET_OLD_RACES = 'get_old_races'
export const GET_OLD_RACES_SUCCESSFUL = 'get_old_races_successful'
export const GET_OLD_RACES_FAILED = 'get_old_races_failed'

export const SEARCH = 'search'
export const SEARCH_SUCCESSFUL = 'search_successful'
export const SEARCH_FAILED = 'search_failed'

export const CLEAR = 'clear'
export const CLEAR_SUCCESSFUL = 'clear_successful'
export const CLEAR_FAILED = 'clear_failed'

export const SET_MODAL = 'set_modal'
export const SET_SCROLL_FALSE = 'set_scroll_false'
export const SET_SCROLL_TRUE = 'set_scroll_true'

export const SET_POPUP = 'set_popup'

export const SET_AGENT = 'set_agent'